type labelProps = {
  text: string;
  labelClassName?: string;
  isRequired?: boolean;
  htmlFor?: string;
};

const Label = ({
  text,
  labelClassName,
  isRequired = false,
  htmlFor,
}: labelProps) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`block font-SFProDisplay text-blue-950 text-sm font-normal mb-2 ${labelClassName}`}
    >
      {text} {isRequired ? <span className="text-red-600">*</span> : ''}
    </label>
  );
};

export default Label;
